export default {
  timing100: '0.25s',
  timing400: '0.4s',
  timing700: '0.6s',
  timing1000: '1s',
  easeOutCurve: 'cubic-bezier(.2, .8, .4, 1)',
  easeInCurve: 'cubic-bezier(.8, .2, .6, 1)',
  easeInOutCurve: 'cubic-bezier(0.4, 0, 0.2, 1)',
}
